<template>
  <q-checkbox
    checked-icon="fl:check_fill_square"
    :color="color"
    :label="label"
    :value="value"
    :size="size"
    dense
    v-bind="$attrs"
    :class="{'rounded-box': rounded}"
    @input="$emit('input', $event)"
  >
    <slot/>
  </q-checkbox>
</template>

<script>
export default {
  name: 'AppCheckbox',
  props: {
    label: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .q-checkbox {
    ::v-deep &__inner {
      width: 0.6em !important;
      min-width: 0.6em !important;
      height: 0.6em;
    }
  }
}

.q-checkbox {
  ::v-deep .fit {
    padding: 2px;
  }
}

::v-deep .q-checkbox {

  &__svg {
    color: $dark !important;
  }

  &__bg {
    border: 1px solid $grey-2;
    border-radius: 4px !important;
  }

  &__inner {
    color: $light-blue-1;
    width: 0.54em !important;
    min-width: 0.54em !important;
    height: 0.54em;

    &:before {
      transform: none !important;
      transition: none !important;
      opacity: 0 !important;
    }
  }
}

.rounded-box {
  ::v-deep .q-checkbox {
    &__bg {
      border-radius: 50% !important;
    }
  }
}
</style>
